import { useParams, type RouteObject } from 'react-router';
import ResetPasswordPage from './pages/reset-password';
import ResetPasswordClient from './pages/reset-password-form';
import InviteLandingPage, { loader as inviteLoader } from './pages/invite';

// Pages for people who are NOT signed in to the admin: app users opening
// an invite link or a password-reset email in a browser. No session
// check, no admin frame.

/** The link in password-reset emails: /reset-password/<token>. */
function ResetPasswordTokenPage() {
  return <ResetPasswordClient token={useParams().token ?? ''} />;
}

function LinkNotValid() {
  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center p-6">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-white mb-2">This link is not valid</h1>
        <p className="text-zinc-400 text-sm">Ask the person who shared it to send you a new one.</p>
      </div>
    </div>
  );
}

export const publicRoutes: RouteObject[] = [
  { path: '/invite/:token', loader: inviteLoader, element: <InviteLandingPage />, errorElement: <LinkNotValid /> },
  { path: '/reset-password/:token', element: <ResetPasswordTokenPage /> },
  // Older emails carried the token as ?token=…
  { path: '/reset-password', element: <ResetPasswordPage /> },
];
